// client/src/pages/AdminDashboard.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  return (
    <div className="p-6 text-center">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
      <p className="mb-6 text-gray-700">Manage Casa Gloria data here.</p>
      <div className="flex flex-col space-y-3">
        <Link to="/adminrooms" className="text-blue-600 hover:underline">View Rooms</Link>
        <Link to="/adminaddroom" className="text-blue-600 hover:underline">Add Room</Link>
        <Link to="/adminblockroom" className="text-blue-600 hover:underline">Block Dates</Link>
      </div>
    </div>
  );
}
